import { render, staticRenderFns } from "./datashareRegisterView.vue?vue&type=template&id=57d2f3a5&scoped=true"
import script from "./datashareRegisterView.vue?vue&type=script&lang=js"
export * from "./datashareRegisterView.vue?vue&type=script&lang=js"
import style0 from "./datashareRegisterView.vue?vue&type=style&index=0&id=57d2f3a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2f3a5",
  null
  
)

export default component.exports